import styled from '@emotion/styled';
import {
  Accordion as ExpansionPanelBase,
  AccordionDetails as ExpansionPanelDetails,
  AccordionSummary as ExpansionPanelSummary,
  Typography,
} from '@material-ui/core';
import { ExpansionPanelProps } from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ClassAttributes, createElement, ReactElement, ReactNode } from 'react';

type Props = ExpansionPanelProps & {
  summary: string | ReactElement<any> | ReactNode;
  className?: string;
};

const ExpansionPanel = ({ summary, children, className, ...props }: ClassAttributes<HTMLElement> & Props) => (
  <ExpansionPanelBase className={className} {...props}>
    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="subtitle1">{summary}</Typography>
    </ExpansionPanelSummary>
    <StyledExpansionPanelDetails>
      <div>{children}</div>
    </StyledExpansionPanelDetails>
  </ExpansionPanelBase>
);

const StyledExpansionPanelDetails = styled(ExpansionPanelDetails)({ '& > *': { width: '100%' } });

export default ExpansionPanel;
